<template>
    <div id="app">
        <router-view name="MainView"></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
    }
</script>

<style></style>
